export enum TerminateInvoiceOperation {
  DuplicateResolution = 0,
  MassTerminate = 1,
  SingleTerminate = 2
}